import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

export default () => {
  const routes = [
    {
      path: "/",
      name: "first",
      component: () => import("../views/login.vue"),
    },
    {
      path: "/login",
      name: "Login",
      component: () => import("../views/login.vue"),
    },
    {
      path: "/index",
      name: "Index",
      component: () => import("../views/index.vue"),
    },
    {
      path: "/mobile",
      name: "mobile",
      component: () => import("../views/mobile.vue"),
    },
    {
      path: "/end",
      name: "End",
      component: () => import("../views/over.vue"),
    },
    {
      path: "/err",
      name: "Err",
      component: () => import("../views/err.vue"),
    },
  ];

  const router = new VueRouter({
    mode: "history",
    base: ["production", "dev", "test"].includes(process.env.NODE_ENV) ? "/cla" : "",
    routes,
  });

  // router.afterEach((to) => {
  //   if(to.path === '/end') {
  //     const isHiddenBrand = store.state.defaultInfo.isHiddenBrand === 'true'
  //     const storeConfigInfo = store.state.defaultInfo.configInfo
  //     let configInfo = ''
  //     if(!storeConfigInfo) {
  //       configInfo = { claTitle: '', favicon: '' }
  //     }else {
  //       console.log('store config info', storeConfigInfo)
  //       configInfo = JSON.parse(storeConfigInfo)
  //     }
  //     updateIconTitle(configInfo, isHiddenBrand)
  //   }
  // })

  return router;
};

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
